// extracted by mini-css-extract-plugin
export default {"image":"Onboarding_image__2Zu6O","ionToolBar":"Onboarding_ionToolBar__ceqYa","content":"Onboarding_content__XfIn1","footer":"Onboarding_footer__OXqJ+"};